import MapHelper from "./helper";

const getFormattedRequestData = (latLongList) => {
  return {
    request: {
      Coords: latLongList.map((location) => ({
        Lat: location.latitude,
        Lon: location.longitude,
      })),
    },
  };
};

const ReverseGeocodingBatch = async (data) => {
  if (!data?.length) {
    return [];
  }
  const url =
    "https://pcmiler.alk.com/apis/rest/v1.0/service.svc/locations/reverse/batch";
  const headers = {
    Authorization: MapHelper.getKey(),
    "Content-Type": "application/json",
  };
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: JSON.stringify(getFormattedRequestData(data)),
  };

  try {
    const response = await fetch(url, requestOptions);
    const result = await response.json();
    return result?.ReverseGeoBatchResult?.filter((result) => !result.Errors.length) || [];
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};

export default ReverseGeocodingBatch;
